import React from 'react';
import { FiAward, FiExternalLink } from 'react-icons/fi';
import {
  Main,
  MaxWidth,
  Title,
  Heading,
  Grid,
  Card,
  Badge,
  Info,
  Name,
  Issuer,
  Foot,
  DateText,
  Verify,
} from './Certifications.elements';
import useInView from '../../useInView';

const CERTS = [
  {
    name: 'AWS Cloud Technical Essentials',
    issuer: 'Amazon Web Services (AWS)',
    date: 'May 2026',
    url: 'https://www.coursera.org/account/accomplishments/certificate/JA1PNB2AD04R',
  },
  {
    name: 'Google Analytics Certification',
    issuer: 'Google Digital Academy (Skillshop)',
    date: 'Mar 2026',
    url: 'https://skillshop.credential.net/5339b4c5-d007-4cfc-a3ea-3e1f88a75981#acc.930POIhD',
  },
  {
    name: 'Arctic Circle Certificate',
    issuer: 'Arctic Circle — Napiiri Polarkreis',
    date: 'Mar 2026',
    url: 'https://drive.google.com/file/d/1s6fq-r8SEhtVbOj1nnmvALDwsXgkJMyb/view?usp=sharing',
  },
  {
    name: 'YetGen 21st Century Competencies',
    issuer: 'Yetkin Gençler',
    date: 'Dec 2025',
    url: 'https://drive.google.com/file/d/13AqJhlnGyEiAFLTFokBYDpH4L_89X16r/view?usp=sharing',
  },
  {
    name: 'Türkiye Turing Social Transcript',
    issuer: 'Türkiye Turing ve Otomobil Kurumu',
    date: 'Jul 2025',
    url: 'https://drive.google.com/file/d/1YoC8c6zm-i0WGVQ_mrS8mlD8faB5_So9/view?usp=sharing',
  },
  {
    name: 'Inter-HS UAV Competition — Finalist',
    issuer: 'TEKNOFEST',
    date: 'Jan 2020',
  },
  {
    name: "Boğaziçi TechSummit '21",
    issuer: 'Boğaziçi University',
    date: 'May 2021',
    url: 'https://verified.sertifier.com/en/verify/06130493371038/',
  },
  {
    name: 'Deployment Workshop',
    issuer: 'Global AI Hub',
    date: 'Mar 2021',
    url: 'https://verified.sertifier.com/en/verify/62514870210817/',
  },
  {
    name: 'Top Learner — Python Programming',
    issuer: 'Global AI Hub',
    date: 'Feb 2021',
    url: 'https://verified.cv/en/verify/39178638649204',
  },
  {
    name: 'Python Programming',
    issuer: 'Global AI Hub',
    date: 'Feb 2021',
    url: 'https://verified.sertifier.com/en/verify/31384435903168/',
  },
  { name: 'Web Programming with React', issuer: 'BTK Akademi', date: 'Jan 2021' },
];

const head = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: 0.08 * i, ease: 'easeOut' },
  }),
};

function CertCard({ cert, index, inView }) {
  return (
    <Card
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 28 }}
      transition={{ duration: 0.45, delay: 0.04 * (index % 8), ease: 'easeOut' }}
    >
      <Badge>
        <FiAward />
      </Badge>
      <Info>
        <Name>{cert.name}</Name>
        <Issuer>{cert.issuer}</Issuer>
        <Foot>
          <DateText>{cert.date}</DateText>
          {cert.url && (
            <Verify href={cert.url} target="_blank" rel="noreferrer">
              Verify <FiExternalLink />
            </Verify>
          )}
        </Foot>
      </Info>
    </Card>
  );
}

function Certifications() {
  const [gridRef, gridInView] = useInView({ amount: 0.05 });

  return (
    <Main id="certifications">
      <MaxWidth>
        <Title variants={head} initial="hidden" animate="visible">
          Credentials
        </Title>
        <Heading variants={head} custom={1} initial="hidden" animate="visible">
          Licenses &amp; Certifications
        </Heading>

        <Grid ref={gridRef}>
          {CERTS.map((c, i) => (
            <CertCard key={c.name} cert={c} index={i} inView={gridInView} />
          ))}
        </Grid>
      </MaxWidth>
    </Main>
  );
}

export default Certifications;
